import React from 'react';
import ReactDOM from 'react-dom';
import '../src/config/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';

import ReactGA from 'react-ga';

import './index.css';

ReactGA.initialize('UA-158059735-1');
ReactGA.pageview(window.location.pathname + window.location.search);


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
